import { atom, RecoilState } from "recoil";
import { recoilPersist } from "recoil-persist";


const { persistAtom } = recoilPersist();
export const RolesAtoms: RecoilState<string[]> = atom<string[]>({
    key: 'RolesAtoms',
    default: [] as string[],
    effects_UNSTABLE : [persistAtom]
});